import {useTranslations} from 'next-intl';
import Container from '@/container';
import {Row, Col} from '@/grid';
import {Grid} from '@/content/features/shared';
import {SectionPaddingHalf} from '@/section';
import styles from './styles.module.scss';

type StatItem = {
  value: string;
  label: string;
};

const StatsSection = () => {
  const t = useTranslations('customers.statsSection');
  const items = t.raw('items') as StatItem[];

  return (
    <SectionPaddingHalf>
      <Container>
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <div className={styles['stats-row']}>
                {items.map((item, index) => (
                  <div key={index} className={styles.stat}>
                    <span className={`heading-2 ${styles.stat__value}`}>{item.value}</span>
                    <p className={styles.stat__label}>{item.label}</p>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Grid>
      </Container>
    </SectionPaddingHalf>
  );
};

export default StatsSection;
